import React, {FC, useMemo} from 'react';
import {InsightCard} from '../../dashboard/insight-card';
import {Insight} from '../interface';
import {formatConfigDate, comparisonConfigDate} from '../insight-options';
import {useInsightActionItemHook} from './action-items-insight-hook';

interface ActionItemCompletionRateProps extends Insight {
  showRangeType?: boolean;
  overallDateRange?: null | {startDate: string; endDate: string};
}

export const ActionItemCompleted: FC<ActionItemCompletionRateProps> = ({
  overallDateRange,
  ...rest
}) => {
  const config = rest.config;

  const formatDate = useMemo(
    () =>
      overallDateRange ? overallDateRange : formatConfigDate(config) || {},
    [config, overallDateRange],
  );

  const comparisonDate = useMemo(
    () => comparisonConfigDate(config, formatDate.startDate),
    [config, formatDate.startDate],
  );

  const {summary} = useInsightActionItemHook({
    members: config.users || [],
    sections: config.list || [],
    date: formatDate,
    comparisonDate: comparisonDate,
  });

  return (
    <InsightCard
      showFlashIcon={Boolean(overallDateRange)}
      {...rest}
      value={summary.completed.current}
      percentProgress={summary.completed.change}
    />
  );
};
